if (!customElements.get('tilo-free-sock-cart-discount')) {
  customElements.define(
    'tilo-free-sock-cart-discount',
    class TiloFreeSockCartDiscount extends HTMLElement {
      connectedCallback() {
        this._onRequestEnd = this._onRequestEnd.bind(this);
        this._debounceTimer = null;
        /** @type {boolean} */
        this._applyFailed = false;
        /** @type {boolean} */
        this._inFlight = false;
        document.addEventListener('liquid-ajax-cart:request-end', this._onRequestEnd);
      }

      disconnectedCallback() {
        document.removeEventListener('liquid-ajax-cart:request-end', this._onRequestEnd);
        if (this._debounceTimer) {
          clearTimeout(this._debounceTimer);
          this._debounceTimer = null;
        }
      }

      /** @returns {Record<string, unknown> | null} */
      getConfig() {
        const el = document.getElementById('tilo-free-sock-cart-config');
        if (!el || !el.textContent) return null;
        try {
          return JSON.parse(el.textContent);
        } catch {
          return null;
        }
      }

      _onRequestEnd() {
        if (this._debounceTimer) clearTimeout(this._debounceTimer);
        this._debounceTimer = setTimeout(() => {
          this._maybeApplyDiscount();
        }, 100);
      }

      async _maybeApplyDiscount() {
        const config = this.getConfig();
        if (
          !config ||
          !config.autoApplyDiscount ||
          typeof config.discountCode !== 'string' ||
          !String(config.discountCode).trim()
        ) {
          return;
        }
        if (this._applyFailed || this._inFlight) return;

        const key = String(config.linePropertyKey || 'Promotion');
        const val = String(config.linePropertyValue || 'Free with TILO');
        const code = String(config.discountCode).trim();

        const root =
          (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) ||
          '/';

        this._inFlight = true;
        try {
          const res = await fetch(`${root}cart.js`);
          if (!res.ok) return;
          /** @type {{ items?: Array<{ properties?: Record<string, string> }>, discount_codes?: Array<{ code?: string }> }} */
          const cart = await res.json();

          const hasPromoLine = (cart.items || []).some((item) => {
            const props = item.properties || {};
            return props[key] === val;
          });
          if (!hasPromoLine) return;

          const codes = cart.discount_codes || [];
          const already = codes.some(
            (d) => d && String(d.code || '').toLowerCase() === code.toLowerCase()
          );
          if (already) return;

          if (typeof window.liquidAjaxCart?.update === 'function') {
            window.liquidAjaxCart.update({ discount: code });
          } else {
            const updateRes = await fetch(`${root}cart/update.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: code }),
            });

            if (!updateRes.ok) {
              this._applyFailed = true;
            }
          }
        } catch {
          this._applyFailed = true;
        } finally {
          this._inFlight = false;
        }
      }
    }
  );
}
